angular.module('picmonicng').directive('plsMenuPlayerAudioSelector', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/pls-menu-player-audio-selector.html',
      controller: [
        '$scope',
        'LearnService',
        function ($scope, LearnService) {
          $scope.LearnService = LearnService;
        },
      ],
    };
  },
]);
